import gql from 'graphql-tag';

import {
  DigitalBundleDetails,
  DigitalBundleTemplateDetails,
  PurchasedDigitalBundleDetails,
} from '../fragments/digital-bundles';

export const digitalBundleCreate = gql`
  mutation digitalBundleCreate($input: DigitalBundleCreateInput!) {
    digitalBundleCreate(input: $input) {
      digital_bundle {
        ...DigitalBundleDetails
      }
    }
  }
  ${DigitalBundleDetails}
`;

export const digitalBundleUpdate = gql`
  mutation digitalBundleUpdate($input: DigitalBundleUpdateInput!) {
    digitalBundleUpdate(input: $input) {
      digital_bundle {
        ...DigitalBundleDetails
      }
    }
  }
  ${DigitalBundleDetails}
`;

export const digitalBundleTemplateCreate = gql`
  mutation digitalBundleTemplateCreate(
    $input: DigitalBundleTemplateCreateInput!
  ) {
    digitalBundleTemplateCreate(input: $input) {
      digital_bundle_template {
        ...DigitalBundleTemplateDetails
      }
    }
  }
  ${DigitalBundleTemplateDetails}
`;

export const digitalBundleTemplateUpdate = gql`
  mutation digitalBundleTemplateUpdate(
    $input: DigitalBundleTemplateUpdateInput!
  ) {
    digitalBundleTemplateUpdate(input: $input) {
      digital_bundle_template {
        ...DigitalBundleTemplateDetails
      }
    }
  }
  ${DigitalBundleTemplateDetails}
`;

export const digitalBundleTemplateDelete = gql`
  mutation digitalBundleTemplateDelete(
    $input: DigitalBundleTemplateDeleteInput!
  ) {
    digitalBundleTemplateDelete(input: $input) {
      success
    }
  }
`;

export const purchasedDigitalBundlePhotosCreate = gql`
  mutation purchasedDigitalBundlePhotosCreate(
    $input: PurchasedDigitalBundlePhotosCreateInput!
  ) {
    purchasedDigitalBundlePhotosCreate(input: $input) {
      success
      purchased_digital_bundle {
        ...PurchasedDigitalBundleDetails
      }
    }
  }
  ${PurchasedDigitalBundleDetails}
`;
